module.exports = __webpack_public_path__ + "img/bg_ranking.e2546295.png";